(function() {
  var AccessController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.CompaniesController = (function(superClass) {
    extend(CompaniesController, superClass);

    function CompaniesController(scope, transitions, modal, companiesService, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.companiesService = companiesService;
      this.http = http;
      this.openEditCompanyLineupsDialog = bind(this.openEditCompanyLineupsDialog, this);
      this.openEditCompanyPagesDialog = bind(this.openEditCompanyPagesDialog, this);
      this.openNewCompanyDialog = bind(this.openNewCompanyDialog, this);
      this.loadCompanies = bind(this.loadCompanies, this);
      CompaniesController.__super__.constructor.call(this, 'companies', this.http);
      this.scope.fullpage = true;
      this.scope.title = 'Companies';
      this.scope.companies = [];
      this.scope.openNewCompanyDialog = this.openNewCompanyDialog;
      this.scope.openEditCompanyPagesDialog = this.openEditCompanyPagesDialog;
      this.scope.openEditCompanyLineupsDialog = this.openEditCompanyLineupsDialog;
      this.loadCompanies();
    }

    CompaniesController.prototype.loadCompanies = function() {
      return this.loadScopeData(this.companiesService.getCompaniesData(), 'companies');
    };

    CompaniesController.prototype.openNewCompanyDialog = function() {
      var dlg;
      dlg = this.modal.open({
        windowClass: 'modal-width',
        templateUrl: 'backend/admin/new-tools/companies/new-company',
        controller: 'Tools.Controllers.NewCompanyController'
      });
      return dlg.result.then((function(_this) {
        return function() {
          return _this.loadCompanies();
        };
      })(this));
    };

    CompaniesController.prototype.openEditCompanyPagesDialog = function(company) {
      return this.modal.open({
        windowClass: 'large_dialog',
        templateUrl: 'backend/admin/new-tools/companies/company-pages',
        controller: 'Tools.Controllers.EditCompanyPagesController',
        resolve: {
          company: (function(_this) {
            return function() {
              return company;
            };
          })(this),
          pages: this.companiesService.getPagesForCompany(company.id),
          reports: this.companiesService.getReportsForCompany(company.id)
        }
      });
    };

    CompaniesController.prototype.openEditCompanyLineupsDialog = function(company) {
      return this.modal.open({
        windowClass: 'medium_dialog',
        templateUrl: 'backend/admin/new-tools/companies/company-lineups',
        controller: 'Tools.Controllers.EditCompanyLineupsController',
        resolve: {
          company: (function(_this) {
            return function() {
              return company;
            };
          })(this),
          lineups: this.companiesService.getLineupsForCompany(company.id),
          crops: this.companiesService.getAllCrops(),
          seedCompanies: this.companiesService.getAllSeedCompanies()
        }
      });
    };

    return CompaniesController;

  })(AccessController);

}).call(this);
